import React, { useEffect, useState } from 'react';

// Store
import { useSelector, useDispatch } from 'react-redux';
import { getAffiliateDetails } from 'store/actions/affiliates';

// Utils
import { getActiveAffiliateId } from 'utils/affiliates';
import PropTypes from 'prop-types';
import { ProductCategoriesEnum } from 'utils/enums';

// Components
import { ProductBox } from 'components';

// Auth
import useAuthentication from 'utils/useAuthentication';

const ProductBoxes = ({ chooseProductFunc, chooseProductText, products, ...props }) => {
    // Store
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);

    // State
    const [productList, setProductList] = useState(null);
    const [productCategory] = useState(ProductCategoriesEnum.Featured);

    // Auth
    const { authenticated } = useAuthentication();

    const defaultAffiliateId = 'penly';

    useEffect(() => {
        if (!products) {
            let affiliateId = defaultAffiliateId;

            if (user && authenticated) {
                affiliateId = getActiveAffiliateId(user);
            }

            (async () => {
                const affiliate = await dispatch(getAffiliateDetails(affiliateId));
                if (affiliate) {
                    setProductList(Object.values(affiliate.products).filter(p => !p.hidden && p.categories.find((c) => c === productCategory.id)));
                }
            })();
        } else {
            setProductList(products);
        }
    }, [user, products, authenticated, dispatch]);

    return (
        <>
            <div className="productBoxes" { ...props }>
                { productList &&
                    productList.map(product => <ProductBox elementId={ product.id } chooseProductFunc={ chooseProductFunc } chooseProductText={ chooseProductText }
                        product={ product } key={ product.id } />) }
            </div>
        </>
    );
};

ProductBoxes.propTypes = {
    chooseProductFunc: PropTypes.func,
    chooseProductText: PropTypes.string,
    products: PropTypes.array,
};

export default ProductBoxes;
